import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import { useIntl } from 'react-intl';
import Button from '../../../../../../atoms/buttons/Button';
import TruncateTextWithButton from '../../../../../../molecules/merchant/common/buttons/TruncateTextWithButton';

import css from './Staff.module.scss';
import { MerchantBookingStaffImageApi } from '../../../../../../interfaces/merchants/bookings/staff';

interface Props {
  staffName: string;
  image?: MerchantBookingStaffImageApi;
  description?: string;
  href: string;
}

const Staff: React.FC<Props> = ({ staffName, image, description, href }) => {
  const intl = useIntl();
  const classes = classNames(css.Staff);
  return (
    <div className={classes} data-style={description ? 'wrap' : 'noWrap'}>
      {image && image.url && (
        <img className={css.Staff__Img} alt={staffName} src={image.url} />
      )}
      <div
        className={css.Staff__Texts}
        data-style={image && image.url && 'hasImage'}
      >
        <p className={css.Staff__Name}>{staffName}</p>
        {description && (
          <TruncateTextWithButton
            className={css.Staff__Description}
            text={description}
            maxLine={7}
          />
        )}
      </div>
      <div className={css.Staff__ButtonContainer}>
        <Link href={href} prefetch={false} legacyBehavior>
          <Button
            href={href}
            isGhost={true}
            className_Deprecated={css.Staff__Button}
          >
            {intl.formatMessage({ id: 'merchants.bookingPages.staff.select' })}
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Staff;
